// 将base64 的图片转换成file对象上传 atob将ascii码解析成binary数据
export function base64_tofile(data) {
  let binary = window.atob(data.split(',')[1]);
  let mime = data.split(',')[0].match(/:(.*?);/)[1];
  let array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  let fileData = new Blob([new Uint8Array(array)], {
    type: mime,
  });

  let file = new File([fileData], `${new Date().getTime()}.png`, {
    type: mime
  });

  return file;

};
export function getimgfile(url, callback) {

  let _image = new Image();
  _image.src = url;
  // return image

  _image.onload = function() {
    var canvas = document.createElement("canvas");
    canvas.width = _image.width;
    canvas.height = _image.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(_image, 0, 0, _image.width, _image.height);
    var ext = _image.src.substring(_image.src.lastIndexOf(".") + 1).toLowerCase();
    var dataURL
    dataURL = canvas.toDataURL("image/" + ext);

    //dataURL=dataURL.replace(/^data:image\/\w+;base64,/, "")

    dataURL = base64_tofile(dataURL)
    //console.log(dataURL)
    if (dataURL) {
      callback(dataURL)
    }

  }


};
//导出的时间格式
export function format_time(date) {
  let mon = date.getMonth() + 1;
  let day = date.getDate();
  let currDate = date.getFullYear() + "-" + (mon < 10 ? "0" + mon : mon) + "-" + (day < 10 ? "0" + day : day);
  return currDate;
}

// 导出浮点数的整数以及小数部分
export function getnum(num) {
  var b = num.toString().split(".");
  var integer = b[0]; //整数部分
  var decimals = b[1]; //小数部分
  return {
    integer,
    decimals
  };
}
//匹配6~10位由数字和26个英文字母混合而成的密码
export function verify_pwd(str) {
  let regu = "^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$"
  let re = new RegExp(regu)
  if (re.test(str)) {
    return true;
  } else {
    return false;
  }
}

//防止抖动 函数防抖 (只执行最后一次点击)
// zidingyi:fangdou(function(){
// ...
// },1000),
export const fangdou = (fn, t) => {
  let delay = t || 500;
  let timer;
  return function() {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fn.apply(this, args);
    }, delay);
  }
};

//js把字符串分割成数组
export const string_fenge = (str, tag) => {
  let str1 = str;
  let array = [];
  let new_array = [];

  if (str1 && tag) {

    if (str1.search("<br />") != -1) { //查询字符串中是否有<br />，有就转换成<br/>
      let reg = new RegExp("<br />", "g")
      str1 = str1.replace(reg, "<br/>")
    }
    array = str1.replace(/(\n|\r|\r\n)/g, '').split(tag) //去除换行符并转换成数组
    //console.log(array)
    array.forEach((item) => {
      let obj = {}

      if (item) {
        obj.tag = item.slice(0, 1)
        obj.content = item.slice(2)
        new_array.push(obj)
      }
    })



    return new_array
  } else {
    return []
  }
};

//防止浏览器屏蔽window.open()打开新页面
export const window_open = (href) => {
  window.open(href, '_blank');
}
//存储时间戳以及数据
export const set_timeStorage = (storageName, timeNumber, data) => {
  let endMsRes = new Date().getTime() + timeNumber; //当前时间戳加上10分钟的时间戳，相当于当前时间10分钟以后的时间戳
  let obj = {
    time: endMsRes,
    data: data
  }
  localStorage.setItem(storageName, JSON.stringify(obj));
};
//获取存储时间戳以及数据
export const get_timeStorage = (storageName, callback) => {
  let newTime = new Date().getTime(),
    storage_obj = JSON.parse(localStorage.getItem(storageName));
  //console.log(storage_obj)
  if (!storage_obj) {
    callback(false)
    return
  };
  if (!storage_obj.time) {
    callback(false)
  } else {
    if (storage_obj.time - newTime > 0 && storage_obj) {
      callback(storage_obj.data)
    } else {
      callback(false)
    }
  } //end else
};
//
// 用法示例 import {
//    getnum
//  }
//  from '@/utils/utils.js'



// WEBPACK FOOTER //
// ./src/utils/utils.js